import { Card } from "@/components/ui/card";
import { TransactionTypePieChart } from "./charts/TransactionTypePieChart";
import { TransactionAmountLineChart } from "./charts/TransactionAmountLineChart";
import { TransactionCountBarChart } from "./charts/TransactionCountBarChart";

interface TransactionChartsProps {
  transactions: any[];
}

export const TransactionCharts = ({ transactions }: TransactionChartsProps) => {
  if (!transactions || transactions.length === 0) {
    return (
      <div className="text-center p-8 text-gray-500">
        Aucune donnée disponible pour les graphiques
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Répartition par type</h3>
          <div className="h-[300px]">
            <TransactionTypePieChart transactions={transactions} />
          </div>
        </Card>
        
        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Évolution des montants</h3>
          <div className="h-[300px]">
            <TransactionAmountLineChart transactions={transactions} />
          </div>
        </Card>
        
        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Nombre de transactions</h3>
          <div className="h-[300px]">
            <TransactionCountBarChart transactions={transactions} />
          </div>
        </Card>
      </div>
    </div>
  );
};